import { IntlShape } from 'react-intl';
import { IScheduler } from './types';
import { TValueOption } from './ValueCell/ValueCellSelector';
export function getDate(dayString: string) {
  const today = new Date();
  const year = today.getFullYear().toString();
  let month = (today.getMonth() + 1).toString();
  const day = today.getDay().toString();

  if (month.length === 1) {
    month = "0" + month;
  }

  return dayString.replace("YEAR", year).replace("MONTH", month).replace("DAY", day);
}


export const getValueOptions = (app: IScheduler) : TValueOption[] | undefined => {
  return (app.stateTextList && app.stateTextList !== '')  ?
  JSON.parse(app.stateTextList).map((val,index) => ({ label: val, value: index + 1  }))
  : undefined;
}

export function getValue(dataType: string, value: any) {
  if (dataType === 'System.Boolean') {
    if (value === "0")
      return false;
    if (value === "1")
      return true;
    return Boolean(value);
  }

  return Number(value);
}

export function getPrettifiedValueString(dataType: string, value: any, stateTextList: string | undefined, intl: IntlShape): string {


  if (dataType === 'System.Boolean') {
    const isOn = (value === 'true' || value === true || value === '1' || value === 1);
    return isOn ? intl.formatMessage({ id: 'on', defaultMessage: 'ON' }).toUpperCase() : intl.formatMessage({ id: 'off', defaultMessage: 'OFF' }).toUpperCase();
  }

  if (dataType === 'System.Double')
    return Number(value).toFixed(1).toString();

  if (dataType === 'System.Int64' || dataType === 'System.Int32' || dataType === 'System.Enum' || dataType === 'System.UInt32') {
    if (stateTextList && stateTextList !== '') {
      const texts: string[] = JSON.parse(stateTextList);
      return texts[value - 1];
    }
  }
  const num = Number(value);
  if (Number.isInteger(num))
    return num.toString();


  return value.toString();
}